module.exports = __webpack_public_path__ + "static/media/DE.daefe96b.svg";